<template>
  <a-layout>
    <a-layout-header>
      <a-page-header title="智慧点名册" subtitle="快速登分、成绩统计 v0.1" :show-back=false>
        <template #extra>
          <a-dropdown @select="handleSelect" trigger="hover">
            <a-button>{{ userName }}<icon-down /></a-button>
            <template #content>
              <a-doption>退出登录</a-doption>
            </template>
          </a-dropdown>
        </template>
      </a-page-header>
    </a-layout-header>
    <a-layout>
      <a-layout-sider>

          <a-menu :style="{ width: '200px', height: '100%' }" auto-open @menu-item-click="goToPage" :selected-keys="currentPage">
          <a-sub-menu key="0">
            <template #icon><icon-home /></template>
            <template #title>班级管理</template>
            <a-menu-item key="/app/class/list">班级列表</a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="1">
            <template #icon><icon-user-group /></template>
            <template #title>学生管理</template>
            <a-menu-item key="/app/student/list">学生列表</a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="2">
            <template #icon><icon-file /></template>
            <template #title>成绩管理</template>
            <a-menu-item key="/app/homework/uploadScore">成绩录入</a-menu-item>
            <a-menu-item key="/app/homework/downloadRollBook">成绩册导出</a-menu-item>
            <a-menu-item key="/app/homework/statistics">成绩统计</a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="3">
            <template #icon><icon-file /></template>
            <template #title>学期管理</template>
            <a-menu-item key="/app/semester/list">学期列表</a-menu-item>
          </a-sub-menu>
        </a-menu>
        
      </a-layout-sider>
      <a-layout-content style="padding: 0 20px;">
          <router-view></router-view>
      </a-layout-content>

    </a-layout>

  </a-layout>
</template>
  
<script>
const AV = require("leancloud-storage");
import { useRouter } from 'vue-router'
import { IconDown,IconUserGroup,IconHome,IconFile } from '@arco-design/web-vue/es/icon';
import { ref } from 'vue';
export default {
  name: 'IndexTemplate',
  components: {
    IconDown,IconUserGroup,IconFile,IconHome
  },
  setup() {
    const router = useRouter()
    const userName = ref();
    const currentPage = ref([])

    if (!AV.User.current()) {
      router.push("/login")
    }
    else {
      userName.value = AV.User.current().getUsername()
      currentPage.value = [router.currentRoute.value.path]
    }
    function handleSelect(value) {
      if (value == "退出登录") {
        AV.User.logOut();
        router.push("/login")
      }
    }
    function goToPage(key){
      router.push(key)
      currentPage.value = [key]
    }
    return { handleSelect, userName, goToPage, currentPage }
  }
}
</script>